import React, { memo } from "react";
import { useEffect } from "react";
import {
  AppFooterContentLeftWrapper,
  AppFooterContentRightWrapper,
  AppFooterContentWrapper,
} from "./style";
import KTAppFooterSubscribeBar from "../app-footer-subscribe-bar";
import KTAppFooterListView from "../app-footer-list-view";
import {
  HELPFUL_LINKS_ITEMS,
  SITE_MAP_ITEMS,
} from "../../../../common/local-data";

const KTAppFooterContent = memo(() => {
  useEffect(() => {
    const script = document.createElement('script');
    script.text = `
    (function(e,t,o,n,p,r,i){e.visitorGlobalObjectAlias=n;e[e.visitorGlobalObjectAlias]=e[e.visitorGlobalObjectAlias]||function(){(e[e.visitorGlobalObjectAlias].q=e[e.visitorGlobalObjectAlias].q||[]).push(arguments)};e[e.visitorGlobalObjectAlias].l=(new Date).getTime();r=t.createElement("script");r.src=o;r.async=true;i=t.getElementsByTagName("script")[0];i.parentNode.insertBefore(r,i)})(window,document,"https://diffuser-cdn.app-us1.com/diffuser/diffuser.js","vgo");
    vgo('setAccount', '478840397');
    vgo('setTrackByDefault', true);
    vgo('setEmail', 'xuejohn28@gmail.com');

    vgo('process');`;
    document.body.appendChild(script);
  
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  
  return (
    <AppFooterContentWrapper>
      <AppFooterContentLeftWrapper>
        <KTAppFooterSubscribeBar />
      </AppFooterContentLeftWrapper>
      <AppFooterContentRightWrapper>
        <KTAppFooterListView title="SITE MAP" items={SITE_MAP_ITEMS} />
        <KTAppFooterListView
          title="HELPFUL LINKS"
          items={HELPFUL_LINKS_ITEMS}
        />
      </AppFooterContentRightWrapper>
    </AppFooterContentWrapper>
  );
});

export default KTAppFooterContent;
